import DeepLinkChip from "./DeepLinkChip.jsx";

/**
 * Resume cue for an unfinished guided flow (e.g. a half-built Theory of Change).
 * Derived from account state by the orchestrator and surfaced when Decca opens
 * from anywhere — "Je was bezig met je Theory of Change — verder gaan?".
 *
 * @param {object} props
 * @param {string} props.message - The resume prompt text.
 * @param {string} props.label - Deep-link chip label.
 * @param {string} props.to - In-app path back to the flow.
 */
const ResumeChip = ({ message, label, to }) => (
  <div className="decca-resume" role="note">
    <p className="decca-resume-message">{message}</p>
    <DeepLinkChip label={label} to={to} />
  </div>
);

export default ResumeChip;
